import React from 'react';

const Footer = () => {
    return (
        <div>
            <h2 className="text-center p-5 bg-dark text-white">Copyright © 2021 Premier Sports Team</h2>
        </div>
    );
};

export default Footer;